import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import {
  axios_instance,
  updateAxiosHeaders,
} from "../../../api/axios_instance";
import { modalEventListener } from "../../../utils/ModalEventListener";
import {
  decryptRequest,
  encryptRequest,
} from "../../../utils/encryptdecryptrequest";
const GoogleUsersModal = ({ users, setErrorMsg, closeGoogleUsersModal }) => {
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeGoogleUsersModal);
  }, [closeGoogleUsersModal]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userSelected = async (username) => {
    try {
      const reqData = encryptRequest({ username });
      const result = await axios_instance({
        url: "/googleLoginByUsername",
        method: "POST",
        data: { reqData },
      });

      const resData = decryptRequest(result.data.resData);

      const user = resData.user;
      user.token = resData.token;
      user.menuVisibilityObj = resData.menuVisibilityObj;

      dispatch({ type: "add_user", payload: user });
      localStorage.setItem("token", resData.token);
      localStorage.setItem("csrfToken", resData.csrfToken);
      updateAxiosHeaders();
      navigate("/payments/disbursement_list");
    } catch (e) {
      closeGoogleUsersModal();
      const msg = e?.response?.data?.message
        ? e.response.data.message
        : e.message;
      setErrorMsg([true, msg]);
    }
  };

  return ReactDOM.createPortal(
    <>
      <div className="modal-wrapper" id="modal-wrapper">
        <span className="google-modal-content">
          <div className="modal-header login_user google-login-modal-header">
            <button className="close" onClick={closeGoogleUsersModal}>
              <span>&times;</span>
            </button>
            <h5 className="modal-title googgle-modal-title" id="addRunnerLabel">
              Select a User ID to proceed.
            </h5>
          </div>
          <div className="modal-body">
            <table className="google_multi_user">
              {users.map((user, index) => {
                return (
                  <tr key={index}>
                    <td>{user.username}</td>
                    <td>
                      <button
                        className="btn google_login_btn"
                        onClick={() => userSelected(user.username)}
                      >
                        <span className="google_login_btn_text">Select</span>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        </span>
      </div>
    </>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default GoogleUsersModal;
